// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const aiNotesRegeneratedWebhookPathParamsSchema = z.object({
  account_id: z.number().int().describe("Timely Account ID"),
  user_id: z.number().int().describe("Timely User ID"),
});

export const aiNotesRegeneratedWebhookHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("Internal AI bearer token"),
});

/**
 * @description Webhook processed
 */
export const aiNotesRegeneratedWebhook200Schema = z.object({
  message: z.coerce.string(),
  proposal_id: z.optional(z.coerce.string()),
  entry_ids: z.optional(z.array(z.coerce.string())),
});

/**
 * @description Unauthorized (wrong bearer token)
 */
export const aiNotesRegeneratedWebhook401Schema = z.unknown();

export const aiNotesRegeneratedWebhookMutationRequestSchema = z.object({
  ticUserId: z.optional(z.coerce.string()),
  timelyUserId: z.optional(z.number().int()),
  timelyAccountId: z.optional(z.number().int()),
  date: z.string().date(),
  event: z.enum(["generation_completed", "generation_failed"]),
  entry_notes: z.optional(z.object({})),
});

export const aiNotesRegeneratedWebhookMutationResponseSchema = z.lazy(() => aiNotesRegeneratedWebhook200Schema);
